// Keeps Tab / Shift+Tab inside a modal dialog's container. Call it from the
// dialog's own keydown listener; it only acts on Tab and returns true when it
// moved focus.
const FOCUSABLE = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  '[tabindex]:not([tabindex="-1"])',
].join(", ");

export function trapTab(event, container) {
  if (event.key !== "Tab" || !container) return false;
  const focusables = [...container.querySelectorAll(FOCUSABLE)];
  if (!focusables.length) return false;

  const first = focusables[0];
  const last = focusables.at(-1);
  const active = document.activeElement;
  let target = null;
  if (!container.contains(active)) {
    target = event.shiftKey ? last : first;
  } else if (event.shiftKey && active === first) {
    target = last;
  } else if (!event.shiftKey && active === last) {
    target = first;
  }
  if (!target) return false;

  event.preventDefault();
  target.focus();
  return true;
}
